import Vue from 'vue'
import VueRouter from 'vue-router'

const login = r => require.ensure([], () => r(require('@/page/login/login.vue')), 'login');
const home = r => require.ensure([], () => r(require('@/page/home/home.vue')), 'home');
const dashboard = r => require.ensure([], () => r(require('@/page/dashboard/dashboard.vue')), 'dashboard');
const info = r => require.ensure([], () => r(require('@/page/user/info.vue')), 'info');
const single = r => require.ensure([], () => r(require('@/page/single/single.vue')), 'single');
const singleEdit = r => require.ensure([], () => r(require('@/page/single/singleEdit.vue')), 'singleEdit');
const userList = r => require.ensure([], () => r(require('@/page/user/list.vue')), 'userList');
const roleList = r => require.ensure([], () => r(require('@/page/role/list.vue')), 'roleList');
const menuList = r => require.ensure([], () => r(require('@/page/menu/list.vue')), 'menuList');
const columnList = r => require.ensure([], () => r(require('@/page/column/list.vue')), 'columnList');
const news = r => require.ensure([], () => r(require('@/page/news/list.vue')), 'news');
const newsEdit = r => require.ensure([], () => r(require('@/page/news/edit.vue')), 'newsEdit');
const products = r => require.ensure([], () => r(require('@/page/products/list.vue')), 'products');
const productsEdit = r => require.ensure([], () => r(require('@/page/products/edit.vue')), 'productsEdit');
const applications = r => require.ensure([], () => r(require('@/page/applications/list.vue')), 'applications');
const applicationsEdit = r => require.ensure([], () => r(require('@/page/applications/edit.vue')), 'applicationsEdit');
const ads = r => require.ensure([], () => r(require('@/page/ad/list.vue')), 'ads');
const message = r => require.ensure([], () => r(require('@/page/message/list.vue')), 'message');
const systemSeo = r => require.ensure([], () => r(require('@/page/system/seo.vue')), 'systemSeo');

const routes = [
    {
        name:'login',
        path: '/',
        component: login
    },
    {
        path: '/home',
        component: home,
        children:[
            {
                path:'/dashboard',
                component: dashboard
            },
            {
                path:'/info',
                component: info
            },
            {
                path:'/single',
                component: single
            },
            {
                path:'/singleEdit/:id?',
                component: singleEdit,
                props:true
            },
            {
                path:'/userList',
                component: userList
            },
            {
                path:'/roleList',
                component: roleList
            },
            {
                path:'/menuList',
                component: menuList
            },
            {
                path:'/columnList',
                component: columnList
            },
            {
                path:'/news',
                component: news
            },
            {
                path:'/newsEdit/:id?',
                component: newsEdit
            },
            {
                path:'/products',
                component: products
            },
            {
                path:'/productsEdit/:id?',
                component: productsEdit
            },
            {
                path:'/applications',
                component: applications
            },
            {
                path:'/applicationsEdit/:id?',
                component: applicationsEdit
            },
            {
                path:'/ads',
                component: ads
            },
            {
                path:'/message',
                component: message
            },
            {
                path:'/system/seo',
                component: systemSeo
            }
        ]
    }
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
    routes
})

export default router